import { Link, useLocation } from "react-router-dom";
import { Texts, Media } from "../../Object/";
import Nav from "./Nav";
import { useRef, useEffect, useMemo, useState } from "react";
import { useToggle, useOffsetTop } from "../../Hooks";

const Header = () => {
  const location = useLocation();
  const headerRef = useRef(null);
  const { pageOffsetTop, viewportTop } = useOffsetTop(headerRef);
  const [active, setActive] = useState(false); // ファーストビューからスクロール後にactive化
  const [open, toggleOpen] = useToggle(false);

  const border = useMemo(() => {
    // 位置を取得できなかったときは最大サイズとして表示
    if (pageOffsetTop > 800) {
      setActive(true);
    } else {
      setActive(false);
    }
    // 位置に応じてサイズ計算
  }, [pageOffsetTop, viewportTop]);

  useEffect(() => {
    if (open) {
      toggleOpen(false);
    }
  }, [location]);

  return (
    <>
      <header
        ref={headerRef}
        className={
          active || open ? "l-header__wrap l-header__wrap--active" : "l-header__wrap"
        }
      >
        <Link to="/">
          <Media
            src="common/logo-header"
            alt="icon-logo"
            class="l-header__img--logo"
          ></Media>
        </Link>
        <Nav
          remove={[]}
          position="header"
          open={open}
          toggleOpen={toggleOpen}
        />
      </header>

      <button className="l-header__button" onClick={() => toggleOpen()}>
        <Media src="common/icon-menu" alt="menu"></Media>
      </button>
    </>
  );
};

export default Header;
